module.exports = __webpack_public_path__ + "img/tob_15.84ed1de6.svg";